const gcpPaths = ['user', 'loyalty', 'screen', 'recommendation']

export default gcpPaths
